import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { styled, useTheme } from '@mui/material';
import { useUpdateDocMutation } from '../useUpdateDocMutation';

const Container = styled('div')`
  em-emoji-picker {
    --shadow: none;
  }
`;

export const IconEmojiPicker = ({
  handleClose,
  docId,
}: { docId: string; handleClose(): void }) => {
  const { updateDoc } = useUpdateDocMutation();
  const theme = useTheme();

  const HandleSelectEmoji = async (emoji: any) => {
    await updateDoc({
      _id: docId,
      icon: {
        type: 'icon',
        value: emoji.shortcodes,
      },
    });
    handleClose();
  };

  return (
    <Container>
      <Picker
        theme={theme.palette.mode}
        data={data}
        onEmojiSelect={HandleSelectEmoji}
      />
    </Container>
  );
};
